export default __webpack_public_path__ + "8f543c47e410dbefcf281ad5a7696892.png";